import envStore from '@utils/env';
import store from 'app/store';
import axios, { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
// Config Timeout cho tất cả api (1min)
axios.defaults.timeout = 60000;
axios.defaults.timeoutErrorMessage = 'timeout';

export const GetHeader = () => {
  const token = Cookies.get('token');
  const tokenSave = store.getState().user.token;
  // console.log('tokenSave', tokenSave);
  return {
    Authorization: `Bearer ${tokenSave ? tokenSave : token}`
  };
};

const HandleError = (error: any) => {
  console.log('api HandleError', error.response?.status);
  if (error.response) {
    if (error.response.status === 403) {
      // không có quyền thao tác ...
      // Xóa token lưu trong cookies đi
      // Cookies.remove('token');
      // Xóa role lưu trong LC
      // localStorage.removeItem('role');
      // window.location.href = '/login';
    } else if (error.response.status === 401) {
      // lỗi xác thực
      // Xóa token lưu trong cookies đi
      Cookies.remove('token');
      // Xóa role lưu trong LC
      localStorage.removeItem('role');
      window.location.href = '/login';
    }
  }
  return { data: { Status: 0, message: error.message, error: true, messageCode: error.code, data: null } };
};

interface IApiService {
  GET: (path: string, customeURL?: string, timeout?: number) => Promise<AxiosResponse<any> | any>;
  POST: (path: string, data: any, customeURL?: string, timeout?: number) => Promise<AxiosResponse<any> | any>;
  PUT: (path: string, data: any, customeURL?: string) => Promise<AxiosResponse<any> | any>;
  DELETE: (path: string, data?: any, customeURL?: string) => Promise<AxiosResponse<any> | any>;
}

const ApiService: IApiService = {
  GET: (path: string, customeURL?: string, timeout?: number) => {
    if (customeURL) {
      return axios
        .get(customeURL + path, {
          headers: GetHeader(),
          timeout: timeout ? timeout : undefined
        })
        .catch(error => {
          return HandleError(error);
        });
    }
    return axios
      .get(envStore.apiBaseUrl + path, {
        headers: GetHeader(),
        timeout: timeout ? timeout : undefined
      })
      .catch(error => {
        return HandleError(error);
      });
  },
  POST: (path: string, data: any, customeURL?: string, timeout?: number) => {
    if (customeURL) {
      return axios
        .post(customeURL + path, data, {
          headers: GetHeader(),
          timeout: timeout ? timeout : undefined
        })
        .catch(error => {
          return HandleError(error);
        });
    }
    return axios
      .post(envStore.apiBaseUrl + path, data, {
        headers: GetHeader(),
        timeout: timeout ? timeout : undefined
      })
      .catch(error => {
        return HandleError(error);
      });
  },
  PUT: (path: string, data: any, customeURL?: string) => {
    if (customeURL) {
      return axios
        .put(customeURL + path, data, {
          headers: GetHeader()
        })
        .catch(error => {
          return HandleError(error);
        });
    }
    return axios
      .put(envStore.apiBaseUrl + path, data, {
        headers: GetHeader()
      })
      .catch(error => {
        return HandleError(error);
      });
  },
  DELETE: (path: string, customeURL?: string) => {
    if (customeURL) {
      const headers = GetHeader();
      return axios.delete(customeURL + path, { headers }).catch(error => {
        return HandleError(error);
      });
    }
    const headers = GetHeader();
    return axios.delete(envStore.apiBaseUrl + path, { headers }).catch(error => {
      return HandleError(error);
    });
  }
};

export default ApiService;
